import MobileHeader from './mobileHeader';
import React, { useEffect, useState } from "react";
import { useParams, Link } from 'react-router-dom';
import BackButton from "../img/back-button.png"
import LogoDarkAnimator from '../../componetns/logoDarkAnimator'
import { documentToHtmlString } from "@contentful/rich-text-html-renderer"
import parse from 'html-react-parser';
import Vimeo from "@u-wave/react-vimeo";
import * as ctf from 'contentful';
const ProjectDetail = () => {
    let params = useParams()
    console.log("Params", params)
    const [projects, setProjects] = useState([]);
    const client = ctf.createClient({
        space: 'fdtw7gymput4',
        accessToken: '-b6ZWs0OGwtdJjGTqdBxGGG5D5iITPNdSgVKo4stF7E'
    });

    useEffect(() => {

        fetchDataProject();

    }, []);



    const fetchDataProject = async () => {
        try {
            const resp = await client.getEntries({ content_type: 'projects' });
            setProjects(resp.items);
        } catch (error) {
            console.log(error);
        }

    }

    const filtered = projects.filter(item => {
        return item?.sys?.id === params.id;
    });

    console.log("Filter Array", filtered[0])

    return (
        <div style={{ background: "#000" }}>
            <div className="Mobile_header">
                <Link to="/projects" className=" mobile_back" style={{ border: 'none', marginTop: '.5rem', marginLeft: '.5rem' }} >
                    <img src={BackButton} alt="" />
                </Link>
                {/* <img src={LogoMain} alt="logo" /> */}
                <Link to="/">
                    <LogoDarkAnimator />
                </Link>
                <div className=""></div>
            </div>
            <div className="projrct-details-wrap mobile_project" style={{ minHeight: '100vh' }} >
                <h1>{filtered[0]?.fields?.title}</h1>

                <div className="my-2">
                    {filtered[0]?.fields?.longDescription && (
                        parse(documentToHtmlString(filtered[0]?.fields?.longDescription))
                    )}
                </div>
                {filtered[0]?.fields?.videosUrl && (
                    filtered[0]?.fields?.videosUrl.map((video) => {
                        return (
                            <div className="my-3 details_videos">
                                <Vimeo video={video} autoplay muted />
                            </div>

                        )
                    })
                )}
                <div className="post-sldr">

                    {filtered[0]?.fields?.images && (
                        filtered[0]?.fields?.images.map((video) => {
                            return (
                                <div className="post-sldr-img mt-5">
                                    <img src={`https:${video?.fields?.file?.url}`} />
                                </div>
                            )
                        })
                    )}
                    <img src="images/post-sldr-1.jpg" alt="" />
                </div>
            </div>

        </div>
    )
}

export default ProjectDetail